export const environment = {
  production: false,
  appVersion: '2.0.1',
  isDemo: false,
  isSoftion: false,
  showDocs: true,
  demoEnabled: false,
  softionBrandingUrl: 'https://webly.softion.io',
  ecommerceApiUrl: 'https://saas.api.dev.softion.io/api/v1',
  ecommerceApiKey: 'test',
  storageApiUrl: 'https://storage.api.dev.softion.io/api/v1/storage/upload',
  aiProxyUrl: 'http://localhost:3001',
  // Catálogo de componentes (Azure API — vacío hasta que el backend esté listo)
  catalogApiUrl: '',
  catalogApiKey: '',
  designModeBearer: true,
  tenantSlug: 'avon',
  slugSuffix: '',
  managementAppUrl: 'http://localhost:4301',
};
